import { Language } from "./language";
import { TranslationMode } from "./translation-mode";
import { LocalizedString } from "./localized-string";

export enum DefaultNewsCategoryId {
	World = "world",
	Business = "business",
	Technology = "technology",
	Entertainment = "entertainment",
	Sports = "sports",
	Science = "science",
	Health = "health",
}


export interface CategoryDto {
	id: string;
	name: LocalizedString;
	userId: string | null | undefined; // null for default categories
	categoryPrompt: string | null | undefined;
}

export interface CreateCategoryRequest {
	name: string;
	categoryPrompt: string;
}

export interface UpdateCategoryRequest {
	id: string;
	name: string;
	categoryPrompt: string;
}

export interface DeleteCategoryRequest {
	id: string;
}

export interface NewsCategoryResponse {
	categories: CategoryDto[];
	userCategories?: CategoryDto[]; // Optional, only for authenticated users
}

export interface NewsCategoryRequest {
	sourceLang: Language;
	targetLang: Language;
	mode: TranslationMode;
}

export interface CategorySyncStatusDto {
	categoryId: string;
	name: string;
	processedCount: number;
	totalCount: number;
	isSuccess: boolean;
	lockedUntil: string | null;
}

export interface TranslationSyncStatusDto {
	syncId: string;
	sourceLanguage: Language;
	targetLanguage: Language;
	mode: TranslationMode;
	translatedCount: number;
	maxTranslations: number;
	isSuccess: boolean;
	lockedUntil: string | null;
}

export interface PremiumSyncStatusResponse {
	categories: CategorySyncStatusDto[];
	translations: TranslationSyncStatusDto[];
}
